module.exports = __webpack_public_path__ + "static/media/profile-pic-4.de0c6fee.png";